import React from 'react';
import { UploadFileInfo } from '@progress/kendo-react-upload';
import Button from '@components-clean/core/button';
import CoreCheckbox from '@components-clean/core/core-checkbox';
import { FileUploadDialog } from '@components-clean/core/file-upload-dialog/file-upload-dialog';

export const FileUploadPage = () => {
    const [showDialog, setShowDialog] = React.useState(false);

    const progressRef: { [uid: string]: number } = {};
    const requestIntervalRef: { [uid: string]: number } = {};

    // Fake implementation so that it doesn't make a call to an API to upload anything
    const onSaveRequest = (
        files: UploadFileInfo[],
        _options: { formData: FormData; requestOptions: unknown },
        onProgress: (uid: string, event: ProgressEvent<EventTarget>) => void,
    ): Promise<{ uid: string }> => {
        const { uid, name } = files[0];
        progressRef[uid] = 0;

        return new Promise<{ uid: string }>((resolve, reject) => {
            let progress = 0;
            const interval = window.setInterval(() => {
                progress += 10;
                if (progress <= 100) {
                    if (progress === 30 && name.indexOf('error') !== -1) {
                        clearInterval(interval);
                        delete progressRef[uid];
                        // eslint-disable-next-line prefer-promise-reject-errors
                        reject({ uid }); // <-- failure
                    }

                    onProgress(uid, {
                        lengthComputable: true,
                        loaded: progress,
                        total: 100,
                    } as unknown as ProgressEvent);
                }
                if (progress >= 100) {
                    clearInterval(interval);
                    delete progressRef[uid];
                    resolve({ uid });
                }
            }, 300);

            requestIntervalRef[uid] = interval;
        });
    };

    const [fileRestrictions, setFileRestrictions] = React.useState<string[]>([]);
    const [multiple, setMultiple] = React.useState<boolean>(false);

    return (
        <div style={{ width: '700px' }}>
            <h2>File Upload Dialog</h2>
            <p>
                Mimics the behaviour of a file upload, but doesn&#39;t call an API or actually upload the files to any
                storage system Uploading a file with the text <span style={{ color: 'red' }}>&#39;error&#39; </span>
                anywhere in the file name will simulate an error while wile uploading the file
            </p>
            <div className="k-d-flex k-flex-col k-gap-5 k-mb-sm">
                <div>
                    <b>File Restrictions</b>
                    <div>
                        <CoreCheckbox
                            data-testid="jpeg"
                            label=".jpeg"
                            onChange={(x) => {
                                if (x.value) setFileRestrictions((prev) => [...prev, 'jpeg']);
                                else setFileRestrictions((prev) => prev.filter((f) => f !== 'jpeg'));
                            }}
                        />
                        <CoreCheckbox
                            data-testid="png"
                            label=".png"
                            onChange={(x) => {
                                if (x.value) setFileRestrictions((prev) => [...prev, 'png']);
                                else setFileRestrictions((prev) => prev.filter((f) => f !== 'png'));
                            }}
                        />
                        <CoreCheckbox
                            data-testid="txt"
                            label=".txt"
                            onChange={(x) => {
                                if (x.value) setFileRestrictions((prev) => [...prev, 'txt']);
                                else setFileRestrictions((prev) => prev.filter((f) => f !== 'txt'));
                            }}
                        />
                        <CoreCheckbox
                            data-testid="txt"
                            label=".xlsx"
                            onChange={(x) => {
                                if (x.value) setFileRestrictions((prev) => [...prev, 'xlsx']);
                                else setFileRestrictions((prev) => prev.filter((f) => f !== 'xlsx'));
                            }}
                        />
                    </div>
                </div>
                <div>
                    <b>Upload multiple files?</b>
                    <CoreCheckbox
                        data-testid="multiple"
                        label="Multiple"
                        onChange={(x) => {
                            setMultiple(x.value);
                        }}
                    />
                </div>
            </div>
            <Button data-testid="upload-file-btn" primary onClick={() => setShowDialog(true)}>
                Upload File
            </Button>
            {showDialog && (
                <FileUploadDialog
                    saveUrl={onSaveRequest}
                    restrictions={{ allowedExtensions: fileRestrictions }}
                    onClose={() => setShowDialog(false)}
                    multiple={multiple}
                    title="Upload File"
                    label="Select file to upload:"
                />
            )}
        </div>
    );
};
